import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Panel,
  Form,
  Message,
  Row,
  ControlLabel,
  Uploader,
  Table,
  Icon,
  ButtonGroup,
  ButtonToolbar,
  Button,
} from 'rsuite'
import ConfirmWidget from '../confirm/ConfirmWidget'
import classNames from 'classnames'
import { isImageOrPdf, isRequired, isValidators } from '../../utils/ValidatorUtils'
import AppContext from '../../context/AppContext'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { doneLoading, startLoading } from '../../utils/loading'
import { getScrutinizeAttachmentMulti } from '../../redux/actions/scrutinize'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import {
  deleteFile,
  getSchemaReviewSummary,
  getSchemaUploadFileMoreCoi,
  saveReviewSaveMoreFileCoi,
} from '../../redux/actions/reviewSummary'
import { isEmpty, set } from 'lodash-es'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import ApprovedExpertListTable from '../../components/table/approvedExpertListTable/ApprovedExpertListTable'

export default function ReviewSummaryAttachFileCoiWidget({ schema, projectId }) {
  const { register, handleSubmit, errors, control, setValue, getValues, setError, clearErrors } =
    useForm()
  const { theme } = React.useContext(AppContext)
  const { Column, HeaderCell, Cell } = Table

  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)
  const [supportFileError, setSupportFileError] = useState(false)
  const [fileList, setFileList] = useState([])
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [uploadfileList, setUploadfileList] = useState([])
  const [fileId, setFileId] = useState()
  const [formSchemaReviewerSummary, setFormSchemaReviewerSummary] = useState()

  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'
  const defaultMaxFileSize = 5

  useEffect(() => {
    setFileList(formSchema.reviewAttachFile?.value ? formSchema.reviewAttachFile?.value : [])
    // console.log('schema.reviewFile?.value =>', schema.reviewAttachFile.value)
    handleGetSchemareview()
  }, [schema])

  const onPreview = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const file = await getScrutinizeAttachmentMulti(projectId, fileObj.id)
      console.log('deleteFile ', file)

      if (file) {
        previewFile(file, fileObj.name)
      }
    } catch (e) {
      console.log('error : ', e)
    }

    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const file = await getScrutinizeAttachmentMulti(projectId, fileObj.id)

      if (file) {
        downloadFile(file, fileObj.name)
      }
    } catch (e) {
      console.log('error : ', e)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleDeleteFile = async () => {
    console.log('handleDeleteFile ', fileId)
    startLoading()
    setIsLoading(true)

    try {
      const status = await deleteFile(projectId, fileId)
      console.log('deleteFile status ', status)

      if (status === 200) {
        refreshSchema()
      } else {
        setIsDeleteError(true)
      }
      setFileId()
      setIsShowConfirmDelete(false)
    } catch (e) {
      console.log('error : ', e)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleConfDeleteFile = async (fileId) => {
    console.log('handleConfDeleteFile ', fileId)
    setFileId(fileId)
    setIsShowConfirmDelete(true)
  }

  const refreshSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaUploadFileMoreCoi(projectId)

      if (_schema.success) {
        setFormSchema(_schema.model.form)
        setFileList(
          _schema?.model?.form?.reviewAttachFile?.value
            ? _schema?.model?.form?.reviewAttachFile?.value
            : []
        )
      }
    } catch (e) {
      console.log('error', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = async (data) => {
    console.log('onSubmit data => ', data)
    console.log('onSubmit uploadfileList => ', uploadfileList)

    setIsLoading(true)
    startLoading()

    if (uploadfileList === undefined || uploadfileList.length === 0) {
      notification.open('error', {
        title: 'กรุณาเลือกไฟล์ที่ต้องการอัพโหลด',
      })
      doneLoading()
      setIsLoading(false)
      return
    }

    try {
      const formData = new FormData()
      formData.append('ProjectVersionId', projectId || '')

      uploadfileList &&
        uploadfileList?.forEach((element) => {
          formData.append('Files', element.blobFile)
        })

      let response = await saveReviewSaveMoreFileCoi(formData)
      console.log('saveReviewSaveMoreFileCoi response => ', response)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        refreshSchema()
        setUploadfileList([])
        setValue(formSchema?.reviewAttachFile?.name, [])
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: DEFAULT_ERR_MSG,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemareview = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaReviewSummary(projectId)
      console.log('handleGetSchemareview => ', _schema.model.forms.ReviewerApproveList?.itemsList)
      setFormSchemaReviewerSummary(_schema.model.forms.ReviewerApproveList?.itemsList)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {formSchemaReviewerSummary && (
        <>
          <Panel shaded header="" bordered collapsible defaultExpanded>
            <ApprovedExpertListTable
              data={formSchemaReviewerSummary || []}
              hideRound={true}
              //hideInviteLetter={true}
            />
          </Panel>
          <br />
        </>
      )}

      {/* < */}

      <Panel shaded header={formSchema.header || ''} bordered collapsible defaultExpanded>
        <div style={{ marginTop: 20 }}>
          <ErrorMessage error={errors[formSchema?.reviewAttachFile?.name]} />

          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(formSchema.reviewAttachFile?.validators) && 'required'
            )}
          >
            {formSchema.reviewAttachFile?.label}
          </ControlLabel>

          <Row style={{ marginTop: 10 }}>
            {supportFileError && (
              <Message
                style={{ marginTop: 10, marginBottom: 10 }}
                closable
                onClose={() => {
                  setSupportFileError(false)
                }}
                showIcon
                type="error"
                description={`${
                  isNotSupportType
                    ? `อัพโหลดไฟล์ได้เฉพาะที่รองรับเท่านั้น *** ชนิดที่รองรับ ${
                        formSchema.reviewAttachFile?.fileType || defaultSupportType
                      } ***`
                    : ''
                }  ${
                  isOverSize
                    ? ` ขนาดไฟล์เกิน ${
                        formSchema.reviewAttachFile?.fileSize || defaultMaxFileSize
                      } MB `
                    : ''
                }`}
              />
            )}

            <Controller
              key={formSchema?.reviewAttachFile?.name}
              name={formSchema?.reviewAttachFile?.name}
              control={control}
              rules={isValidators(formSchema?.reviewAttachFile?.validators)}
              defaultValue={undefined}
              render={(props) => {
                return (
                  <Uploader
                    accept={formSchema?.reviewAttachFile?.fileType || defaultSupportType}
                    draggable
                    autoUpload={false}
                    multiple={true}
                    fileList={uploadfileList}
                    // fileList={props.value || []}
                    onChange={(fileList) => {
                      console.log('Uploader onChange fileList => ', fileList)
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                        setUploadfileList(undefined)
                      } else {
                        let file = fileList[fileList.length - 1]

                        if (
                          file.blobFile.size >
                          (formSchema?.reviewAttachFile?.fileSize || defaultMaxFileSize) *
                            1024 *
                            1024
                        ) {
                          notification.open('error', {
                            title: `ขนาดไฟล์เกิน ${
                              formSchema?.reviewAttachFile.fileSize || defaultMaxFileSize
                            } MB`,
                            duration: 5000,
                          })
                          return
                        }

                        if (isImageOrPdf(file.blobFile.type)) {
                          props.onChange(fileList)
                          setUploadfileList(fileList)
                          // setFileTypeError(false)
                        } else {
                          // setFileTypeError(true)
                          notification.open('error', {
                            title:
                              'ชนิดที่รองรับ ' + formSchema?.reviewAttachFile.fileType ||
                              '.jpg, .jpeg, .png, .pdf',
                            duration: 5000,
                          })
                          setUploadfileList(undefined)
                        }
                      }
                    }}
                  >
                    <div>
                      <div
                        style={{ lineHeight: '50px' }}
                        className={classNames('uploader', `${theme[0]}-background`)}
                      >
                        <Icon size="4x" icon="upload2" />
                        <small className="uploder__text">
                          <p style={{ wordBreak: 'break-word' }}>
                            คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                          </p>
                        </small>
                      </div>
                    </div>
                  </Uploader>
                )
              }}
            />
          </Row>

          {fileList.length > 0 && (
            <div style={{ marginTop: 10 }}>
              <Table height={300} wordWrap data={fileList}>
                <Column width={80} align="center">
                  <HeaderCell>ไฟล์ที่</HeaderCell>
                  <Cell>
                    {(_, index) => {
                      return index + 1
                    }}
                  </Cell>
                </Column>
                <Column width={250} flexGrow={1}>
                  <HeaderCell>ชื่อไฟล์</HeaderCell>
                  <Cell dataKey="name" />
                </Column>
                <Column width={280} align="center">
                  <HeaderCell></HeaderCell>

                  <Cell>
                    {(rowData, index) => {
                      return (
                        <ButtonToolbar>
                          <ButtonGroup>
                            <Button
                              size="xs"
                              appearance={'primary'}
                              color="blue"
                              onClick={() => {
                                onPreview(rowData)
                              }}
                            >
                              <Icon icon="eye" size="lg" />
                              {'  '}แสดง
                            </Button>
                            <Button
                              size="xs"
                              appearance={'primary'}
                              onClick={() => {
                                onDownload(rowData)
                              }}
                            >
                              <Icon icon="download2" size="lg" />
                              {'  '}ดาวน์โหลด
                            </Button>
                            <Button
                              size="xs"
                              appearance={'primary'}
                              color="red"
                              onClick={() => {
                                // handleDeleteFile(rowData.id)
                                handleConfDeleteFile(rowData.id)
                              }}
                            >
                              <Icon icon="trash" size="lg" />
                              {'  '}ลบ
                            </Button>
                          </ButtonGroup>
                        </ButtonToolbar>
                      )
                    }}
                  </Cell>
                </Column>
              </Table>
            </div>
          )}

          <ConfirmWidget
            title={`ยืนยันการลบเอกสารแนบ`}
            show={isShowConfirmDelete}
            detail={`ยืนยันการลบเอกสารแนบ `}
            onCancle={() => setIsShowConfirmDelete(false)}
            onConfirm={handleDeleteFile}
          />
        </div>

        <hr />

        <SaveButton onClick={handleSubmit(onSubmit)}>บันทึก</SaveButton>
      </Panel>
    </>
  )
}
